import { CustomLoadingService } from './../../shared/custom-loading/custom-loading.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { AuthenticationService } from '../authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.css']
})
export class LoginAsComponent implements OnInit {
  
    accessToken: string = "";
    showFooter = false;
    loginUrl="";
    hasError=false;
    loginMessage =this.translate.instant("Common.RequestInProcess");
    constructor(
      private translate:TranslateService,
      private route: Router, private appSettingService: AppSettingService, private customLoadingService: CustomLoadingService, private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService) {
      
      this.activatedRoute.params.subscribe(p => {
               this.accessToken = p ['token'];
      
      });
  
    }
  
    ngOnInit() {  


      this.appSettingService.flushLoggedInUser();
      this.customLoadingService.show();
     
      this.authenticationService.loginAsMember(this.accessToken).subscribe(response => {
     
        if (response && response.access_token) {
          this.appSettingService.loggedInUser = response;
          if (JSON.parse(this.appSettingService.loggedInUser.Menus).MainMenus.length > 0) {
            let menus = JSON.parse(this.appSettingService.loggedInUser.Menus)

            let mainMenus: any = [];
            let moreMenus: any = [];
            mainMenus = menus.MainMenus.filter(m => m.IsCustomMenu == 0)
            moreMenus = menus.MoreMenus.filter(m => m.IsCustomMenu == 0)

            if (mainMenus != undefined && mainMenus.length > 0) {
              this.appSettingService.landingScreenUrl = mainMenus[0].Link
            } else if (moreMenus != undefined && moreMenus.length > 0) {

              this.appSettingService.landingScreenUrl = moreMenus[0].Link

            }
            else
              this.appSettingService.landingScreenUrl = "/settings";
          }
         
          AppSettingService.userLoggedIn.next(response)
        }
      },
        () => {
  
          this.customLoadingService.hide();
          this.loginMessage = this.translate.instant("AuthorizationDenied");
          this.hasError=true;
        },
        () => {
          this.customLoadingService.hide();
          this.route.navigate([this.appSettingService.landingScreenUrl]);
        });;
  
    }
  
  }
  